// extracted by mini-css-extract-plugin
export var root = "BoxOption-module--root--49993";
export var option = "BoxOption-module--option--c986b";
export var isActive = "BoxOption-module--isActive--8244a";